import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import {catchError, map, mergeMap, switchMap, tap} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {
  loadProfileLists,
  loadProfileListsSuccess,
  loadProfileListsFailure,
} from './profileList.actions';
import { ProfileListService } from '../../services/profile-list.service';

@Injectable()
export class ProfileListEffects {

  loadProfileLists$ = createEffect(() => this.actions$.pipe(
    ofType(loadProfileLists), // Ensuring it is listening to the correct action
    // tap(() => console.log('loadProfileLists effect triggered')), // Logging when effect is triggered
    switchMap(() =>
      this.profileListService.getProfileLists()
        .pipe(
          // tap(data => console.log('Profile lists fetched:', data)), // Logging the data right after fetching
          map(data => {
            // console.log('Mapping data to success action', data); // Log data before mapping to success
            return loadProfileListsSuccess({ profileLists: data.profileLists });
          }),
          catchError(error => {
            console.error('Error fetching countries:', error); // Log the error
            return of(loadProfileListsFailure({ error }));
          })
        )
    )
  ));

  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private profileListService: ProfileListService
  ) {}
}
